'use client';

import { RosterLevelType } from '@wwe-portal/entities/roster.type';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { useMemo } from 'react';
import { useRouter } from 'next/navigation';

import { FAQ_KEYS } from '@wwe-portal/web/providers/queries/subscription';
import { rosterPriceSheet } from './constants';

const getCurrentPrice = ({
  level,
  star,
  hollowStar,
}: Partial<{
  level: RosterLevelType;
  star: number;
  hollowStar: number;
}>): number | null => {
  if (level == undefined || star == undefined || hollowStar == undefined)
    return null;
  const key = `${star + hollowStar}S${level}`;
  return rosterPriceSheet[key] || 0;
};

export const calculateFusingCost = ({
  currentLevel,
  nextLevel,
  currentStar,
  nextStar,
  hollowStar,
}: Partial<{
  currentLevel: RosterLevelType;
  nextLevel: RosterLevelType;
  currentStar: number;
  nextStar: number;
  hollowStar: number;
}>): number => {
  if (
    currentLevel == undefined ||
    nextLevel == undefined ||
    currentStar == undefined ||
    nextStar == undefined
  )
    return 0;
  if (currentLevel === nextLevel && currentStar === nextStar) return 0;
  const currentValue = getCurrentPrice({
    level: currentLevel,
    star: currentStar,
    hollowStar,
  });
  const nextValue = getCurrentPrice({
    level: nextLevel,
    star: nextStar,
    hollowStar: 0,
  });

  if (currentValue == null || nextValue == null) return 0;
  return nextValue - currentValue;
};

export const useRosterListSize = () => {
  const { isTablet, isDesktop, isUltra } = useResponsive();
  return useMemo(() => {
    if (isUltra) return 10;
    if (isDesktop || isTablet) return 6;
    return 4;
  }, [isTablet, isDesktop, isUltra]);
};

export const useSubscriptionHistory = () => {
  const route = useRouter();
  const goAddClubCoin = () => {
    route.push(`/subscription?faq-item=${FAQ_KEYS.HOW_TO_EARN_CLUB_COINS}`);
  };
  const goToSubscription = () => route.push('/subscription');
  return {
    goAddClubCoin,
    goToSubscription,
  };
};
